import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useCallback } from 'react';

import { staffApi } from '../api/staff';

export const useUnlinkUsers = () => {
  const queryClient = useQueryClient();

  const onSuccess = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['roles'] });
    message.success('Desvinculação realizada com sucesso.');
  }, [queryClient]);

  const onError = useCallback(() => {
    message.error('Desvinculação não realizada. Tente novamente.');
  }, []);

  const { mutateAsync: unlikeUsers, isPending: isLoadingUnlinkUsers } =
    useMutation({
      mutationFn: (roleId: number) => staffApi.unlinkUsers(roleId),
      onSuccess,
      onError,
    });
  return { unlikeUsers, isLoadingUnlinkUsers };
};
